import React from "react";
import { Box, Typography } from "@mui/material";

export default function GaugeChartMUI({
  value,
  max,
  title,
  color,
  size = 120,
}) {
  const percentage = (value / max) * 100;
  const strokeWidth = 8;
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * Math.PI; // Half circle
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box position="relative" sx={{ width: size, height: size / 2 + 20 }}>
        <svg
          width={size}
          height={size / 2 + 20}
          viewBox={`0 0 ${size} ${size / 2 + 20}`}
        >
          {/* Background arc */}
          <path
            d={`M ${strokeWidth / 2} ${size / 2} A ${radius} ${radius} 0 0 1 ${
              size - strokeWidth / 2
            } ${size / 2}`}
            fill="none"
            stroke="#e5e7eb"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
          />
          {/* Progress arc */}
          <path
            d={`M ${strokeWidth / 2} ${size / 2} A ${radius} ${radius} 0 0 1 ${
              size - strokeWidth / 2
            } ${size / 2}`}
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={strokeDasharray}
            strokeDashoffset={strokeDashoffset}
            style={{
              transition: "stroke-dashoffset 1s ease-out",
            }}
          />
        </svg>
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          pt={4}
        >
          <Typography sx={{ fontSize: "29px", fontWeight: 400 }}>
            {value} / {max}
          </Typography>
          {/* <Typography sx={{ fontSize: "18px", fontWeight: 400 }}></Typography> */}
        </Box>
      </Box>
      {title && (
        <Typography
          sx={{ fontSize: "18px", fontWeight: 400, textAlign: "center", mt: 1 }}
        >
          {title}
        </Typography>
      )}
    </Box>
  );
}
